// src/components/Footer.jsx
import React, { useEffect, useState } from 'react';
import {
  Fab, useScrollTrigger, Zoom,
  Typography, Box, IconButton, Grid
} from '@mui/material';
import {
  KeyboardArrowUp as ArrowUpIcon,
  Instagram, WhatsApp, YouTube, Facebook, Twitter
} from '@mui/icons-material';

import { footerConfigs } from './footerConfigs';

const ScrollTop = ({ children }) => {
  const trigger = useScrollTrigger({ disableHysteresis: true, threshold: 100 });
  return (
    <Zoom in={trigger}>
      <Fab
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        sx={{ position: 'fixed', bottom: 16, right: 16 }}
        color="primary"
        aria-label="scroll back to top"
      >
        {children}
      </Fab>
    </Zoom>
  );
};

export default function Footer() {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    // 1. Read customer ID however you choose:
    const customerId = process.env.REACT_APP_CUSTOMER_ID || 'bheema';
    // 2. Load config
    setConfig( footerConfigs[customerId] );
  }, []);

  if (!config) return null; // or a simple fallback

  const { brandName, contact, socialLinks } = config;

  // Helper to map icon keys → components
  const iconMap = {
    instagram: <Instagram />,
    whatsapp:   <WhatsApp />,
    youtube:    <YouTube />,
    facebook:   <Facebook />,
    twitter:    <Twitter />,
  };

  return (
    <>
      <footer style={{ padding: 20, background: '#333', color: '#fff', marginTop: 50 }}>
        <Box sx={{ textAlign: 'center', mb: 2 }}>
          <Grid container justifyContent="center" spacing={3}>
            {Object.entries(socialLinks).map(([channel, url]) =>
              url ? (
                <Grid item key={channel}>
                  <IconButton
                    component="a"
                    href={url}
                    target="_blank"
                    rel="noopener"
                    aria-label={channel}
                    sx={{ color: '#fff' }}
                  >
                    {iconMap[channel]}
                  </IconButton>
                </Grid>
              ) : null
            )}
          </Grid>
        </Box>

        <Typography variant="body1" align="center">
          Contact Us: {contact}
        </Typography>
        <Typography variant="body2" align="center" sx={{ mt: 2 }}>
          &copy; {new Date().getFullYear()} {brandName}. All rights reserved.
        </Typography>
      </footer>

      <ScrollTop>
        <ArrowUpIcon />
      </ScrollTop>
    </>
  );
}
